export enum ErrorCode {
  AccessNoRead = 'record.access.no_read',
}

export enum ErrorVariant {
  NotFound = 'NotFound',
  InternalServerError = 'InternalServerError',
  UnknownError = 'UnknownError',
  AccessDeniedError = 'AccessDeniedError',
}

export const ERROR_PROPS = {
  [ErrorVariant.NotFound]: {
    title: 'Page not found',
    headline: 'Page not found',
    text: 'The page you were looking for does not exist.',
    image: <div className="spaceman" />,
  },
  [ErrorVariant.InternalServerError]: {
    title: 'Server Error',
    headline: 'Server Error',
    text: "This wasn't you, it was us. Please try again later.",
    image: <div className="spaceman" />,
  },
  [ErrorVariant.UnknownError]: {
    title: 'Server Error',
    headline: 'Server Error',
    text: "This wasn't you, it was us. Please try again later.",
    image: <div className="spaceman" />,
  },
  [ErrorVariant.AccessDeniedError]: {
    title: 'Permission denied',
    headline: 'Permission denied',
    text: 'Please contact your admin.',
    image: <div className="spaceman-lock" />,
  },
}

export const DATA_SCOPE_ERROR = 'Data scope is not defined!'
